"use client";
import { Footer } from "@/src/components/Footer";
import { Navbar } from "@/src/components/Navbar";
import { ScrollToTop } from "@/src/components/ScrollToTop";
import React from "react";
import { ClientTopLoader } from "@/src/components/ClientTopLoader";

const RootLayout: React.FC<RootLayoutProps> = (props) => {
  const { children } = props;

  return (
    <>
      <ClientTopLoader />
      <div className="min-h-screen bg-gradient-to-br from-page-gradient-from via-page-gradient-via to-page-gradient-to transition-colors duration-500 relative overflow-hidden">
        {/* Grain texture overlay */}
        <div
          className="fixed inset-0 pointer-events-none opacity-[0.4] dark:opacity-[0.25]"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='2.5' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
            zIndex: 9999,
          }}
        />

        {/* Minimal decorative background for glassmorphism depth */}
        <div className="fixed inset-0 z-0 pointer-events-none">
          {/* Subtle gradient orbs */}
          <div className="absolute top-[-10%] right-[-5%] w-[800px] h-[800px] bg-walnut-200/30 dark:bg-grey-800/15 rounded-full blur-[120px]" />
          <div className="absolute bottom-[-10%] left-[-5%] w-[700px] h-[700px] bg-beige-200/20 dark:bg-grey-900/20 rounded-full blur-[100px]" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-grey-200/20 dark:bg-grey-800/10 rounded-full blur-[100px]" />
        </div>

        <div className="relative z-10">
          <Navbar />
          <main>{children}</main>
          <Footer />
          <ScrollToTop />
        </div>
      </div>
    </>
  );
};

interface RootLayoutProps {
  children: React.ReactNode;
}

export default RootLayout;
